import { EventEmitter, inject, Injectable } from '@angular/core';
import { Amplify, Auth } from 'aws-amplify';
import { environment } from '../../environments/environment';

import { AuthService } from './auth.service';
import { GlobalService } from './global.service';
import { IUser } from './iuser';

@Injectable({
  providedIn: 'root',
})
export class CognitoService {
  public authNotifier: EventEmitter<any> = new EventEmitter<any>();

  private authService = inject(AuthService);
  constructor(private globalService: GlobalService) {
    Amplify.configure({
      Auth: environment.cognito,
    });
  }
  notifyAuthStatus(status: boolean) {
    this.authNotifier.next(status);
  }

  forgotPassword(email: string): Promise<any> {
    return Auth.forgotPassword(email);
  }

  confirmForgotPassword(
    email: string,
    code: string,
    newPassword: string
  ): Promise<any> {
    return Auth.forgotPasswordSubmit(email, code, newPassword);
  }

  async changePassword(
    email: string,
    oldPassword: string,
    newPassword: string
  ): Promise<any> {
    const user = await Auth.signIn(email, oldPassword);
    return Auth.completeNewPassword(user, newPassword);
  }

  async getToken() {
    try {
      const session = await Auth.currentSession();
      const token = session.getAccessToken().getJwtToken();
      const idtoken = session.getIdToken().getJwtToken();
      return { accessToken: token, idToken: idtoken };
    } catch (error) {
      console.error('Error getting token', error);
      throw error;
    }
  }
  async getIdToken() {
    try {
      const session = await Auth.currentSession();
      const idToken = session.getIdToken().getJwtToken();
      return idToken;
    } catch (error) {
      console.error('Error getting token', error);
      throw error;
    }
  }

  signIn(user: IUser): Promise<any> {
    return Auth.signIn(user.email, user.password);
  }

  signOut(): Promise<any> {
    this.globalService.setLoggedIn(false);
    this.authService.reset();
    sessionStorage.clear();
    localStorage.clear();
    return Auth.signOut();
  }

  updateUser(user: IUser): Promise<any> {
    return Auth.currentUserPoolUser().then((cognitoUser: any) => {
      return Auth.updateUserAttributes(cognitoUser, user);
    });
  }
  public isAuthenticated(): Promise<any> {
    return Auth.currentAuthenticatedUser()
      .then((user) => {
        // console.log("User is authenticated", user);
        return user;
      })
      .catch((error) => {
        console.log('User is not authenticated', error);
        return null;
      });
  }

  public getUser(): Promise<any> {
    return Auth.currentUserInfo();
  }
}
